// ./src/components/purchase/purchase_entry.js
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { pathSpliter, currentDateTime } from "../../lib/functions";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import swal from "sweetalert";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import LoadingButton from "../commons/LoadingButton";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DateFnsUtils from "@date-io/date-fns";
import { API_URL } from "../../config";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import socketIOClient from "socket.io-client";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import commaNumber from "comma-number";

// Excel helpers (shared with Opening Stock)
import {
  readExcelRows,
  validateExcelRows,
  toPurchaseCartItems,
} from "../../lib/excelImport";

let format = commaNumber.bindWith(",", ".");

const PurchaseEntry = ({
  location,
  currentRoute,
  currentRouteSet,
  authInfo,
}) => {
  const classes = useStyles();
  const history = useHistory();

  // ---- basic state
  const [selectedDate, handleDateChangeSet] = useState(currentDateTime);
  const [saveAction, saveActionSet] = useState(false);

  let [selectedSupplierPayMethod, selectedSupplierPayMethodSet] = useState({
    pay_method_id: "cash",
    pay_method: "cash",
  });
  let [selectedSupplierPayAcc, selectedSupplierPayAccSet] = useState(null);
  let [supplierPayAccs, supplierPayAccsSet] = useState([]);

  let supplierPayMethods = [
    { pay_method_id: "cash", pay_method: "cash" },
    { pay_method_id: "bank", pay_method: "bank" },
  ];

  let [purchaseData, setPurchaseData] = useState({
    invoice_no: "",
    pur_emp_id: 0,
    pur_created_isodt: currentDateTime,
    pur_supplier_id: 0,
    pur_subtotal_amount: 0,
    pur_vat_amount: 0,
    pur_vat_percent: 0,
    pur_ait_amount: 0,
    pur_ait_percent: 0,
    pur_discount_amount: 0,
    pur_discount_percent: 0,
    pur_total_amount: 0,
    pur_paid_amount: 0,
    pur_due_amount: 0,
    pur_transport_cost: 0,
    supplier_address: "",
    supplier_mobile_no: "",
    supplier_name: "",
    pur_note: "",
    pur_previous_due: 0,
    pur_supplier_type: "",
  });

  let [employees, employeesSet] = useState([]);
  let [suppliers, suppliersSet] = useState([]);
  let [floors, floorsSet] = useState([]);
  let [racks, racksSet] = useState([]);
  let [purchaseCart, purchaseCartSet] = useState([]);
  let [storageCart, storageCartSet] = useState([]);
  let [subTotal, subTotalSet] = useState(0);
  let [po_id, po_id_set] = useState("");

  let [purTotalAmo, purTotalAmoSet] = useState(0);
  let [purPaidAmo, purPaidAmoSet] = useState(0);
  let [purDueAmo, purDueAmoSet] = useState(0);

  let [contactPersons, contactPersonsSet] = useState([]);
  let [selectedContactPerson, selectedContactPersonSet] = useState("");
  let [pur_vat_percent, pur_vat_percent_set] = useState(0);
  let [pur_vat_amount, pur_vat_amount_set] = useState(0);
  let [pur_ait_percent, pur_ait_percent_set] = useState(0);
  let [pur_ait_amount, pur_ait_amount_set] = useState(0);
  let [pur_discount_percent, pur_discount_percent_set] = useState(0);
  let [pur_discount_amount, pur_discount_amount_set] = useState(0);

  // --- keep track of which field user last edited (amount vs percent)
  const [vatMode, setVatMode] = useState("percent"); // "percent" | "amount"
  const [aitMode, setAitMode] = useState("percent"); // "percent" | "amount"
  const [discountMode, setDiscountMode] = useState("amount"); // "percent" | "amount"

  const num = (v) => {
    const x = parseFloat(v);
    return Number.isFinite(x) ? x : 0;
  };
  const round2 = (x) => Math.round((num(x) + Number.EPSILON) * 100) / 100;
  const normalizePurchaseRate = (value) => Number(num(value).toFixed(6));
  const getPurchaseMergeKey = (item) =>
    [
      item?.prod_id ?? 0,
      item?.prod_floor_id ?? 0,
      item?.prod_rack_id ?? 0,
      normalizePurchaseRate(item?.prod_purchase_rate ?? 0),
    ].join("|");

  const mergePurchaseRow = (prevRows, nextItem) => {
    const rows = Array.isArray(prevRows) ? [...prevRows] : [];
    const nextKey = getPurchaseMergeKey(nextItem);
    const nextQty = num(nextItem?.prod_qty);
    const nextRate = normalizePurchaseRate(nextItem?.prod_purchase_rate ?? 0);
    const nextTotal = round2(nextQty * nextRate);
    const existingIndex = rows.findIndex(
      (row) => getPurchaseMergeKey(row) === nextKey
    );

    if (existingIndex > -1) {
      const current = rows[existingIndex];
      const mergedQty = round2(num(current?.prod_qty) + nextQty);
      rows[existingIndex] = {
        ...current,
        ...nextItem,
        prod_qty: mergedQty,
        prod_purchase_rate: nextRate,
        prod_total: round2(mergedQty * nextRate),
      };
      return rows;
    }

    rows.push({
      ...nextItem,
      prod_qty: nextQty,
      prod_purchase_rate: nextRate,
      prod_total: nextTotal,
    });
    return rows;
  };

  // prevent Enter from triggering navigation/submit
  const stopEnter = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  let [selectedEmployee, selectedEmployeeSet] = useState(null);
  let [selectedQC, selectedQCSet] = useState(null);
  let [selectedSupplier, selectedSupplierSet] = useState(null);
  let [selectedProduct, selectedProductSet] = useState(null);
  let [selectedRack, selectedRackSet] = useState(null);
  let [selectedFloor, selectedFloorSet] = useState(null);
  let [filteredRacks, setFilteredRacks] = useState([]);
  let [individualProducts, setIndividualProducts] = useState([]);

  // ---- product form (declare early to avoid TDZ)
  let [product, setProduct] = useState({
    prod_id: "",
    prod_qty: "",          // quantity to purchase
    prod_due_qty: 0,       // due quantity from previous purchase
    prod_received_qty: 0,  // received quantity from database (readonly)
    prod_purchase_rate: "",
    prod_sale_rate: "",
    prod_total: "",
    prod_brand: "",
    prod_color: "",
  });
  const [cartTotal, cartTotalSet] = useState(0);

  const [product_brand, product_brand_set] = useState("");
  const [product_color, product_color_set] = useState("");

  const [floor, setFloor] = useState({ prod_floor_id: 0, prod_floor_name: "" });
  const [rack, setRack] = useState({ prod_rack_id: 0, prod_rack_name: "" });

  // ---- Excel state
  const [excelFile, setExcelFile] = useState(null);
  const [excelFileError, setExcelFileError] = useState(null);
  const [excelImportStatus, setExcelImportStatus] = useState(null);

  // ---- refs
  let employeeRef = React.useRef(null);
  let purchaseDateRef = React.useRef(null);
  let supplierRef = React.useRef(null);
  let contactPersonRef = React.useRef(null);
  let purchaseRateRef = React.useRef(null);
  let productRef = React.useRef(null);
  let floorRef = React.useRef(null);
  let rackRef = React.useRef(null);
  let quantityRef = React.useRef(null);
  let dueQuantityRef = React.useRef(null);
  let purchaseToCartRef = React.useRef(null);
  let subTotalRef = React.useRef(null);
  let vatRef = React.useRef(null); // VAT (TK)
  let aitRef = React.useRef(null); // AIT (TK)
  let discountRef = React.useRef(null); // Discount (TK)
  let discountPercentRef = React.useRef(null); // Discount (%)
  let transportRef = React.useRef(null);
  let purTotalRef = React.useRef(null);
  let paidRef = React.useRef(null);
  let dueRef = React.useRef(null);
  let savePurchaseRef = React.useRef(null);

  // ---- handlers
  const handleFromInput = (e) => {
    const { name, value } = e.target;
    setPurchaseData({ ...purchaseData, [name]: value });
  };
  const handleTotalInput = (e) => {
    const { name, value } = e.target;
    setPurchaseData({ ...purchaseData, [name]: value });
  };
  const handlePaidInput = (e) => {
    purPaidAmoSet(e.target.value);
  };
  const handleDueInput = (e) => {
    purDueAmoSet(e.target.value);
  };
  const productHandle = (e) => {
    const { name, value } = e.target;
    if (name === "prod_qty" || name === "prod_due_qty") {
      if (value === "" || /^\d+$/.test(value)) {
        setProduct((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setProduct((prev) => ({ ...prev, [name]: value }));
    }
  };

  // ---- derived totals
  useEffect(() => {
    // Grand Total = (Subtotal - Discount) + VAT + AIT + Transport
    const afterDiscount = num(subTotal) - num(pur_discount_amount);
    let totalBill =
      afterDiscount +
      num(pur_vat_amount) +
      num(pur_ait_amount) +
      num(purchaseData.pur_transport_cost);

    purTotalAmoSet(Number.isFinite(totalBill) ? round2(totalBill) : 0);
  }, [
    subTotal,
    pur_vat_amount,
    pur_ait_amount,
    purchaseData.pur_transport_cost,
    pur_discount_amount,
  ]);

  useEffect(() => {
    if (selectedSupplier != null && selectedSupplier.supplier_id == 0) {
      purPaidAmoSet(purTotalAmo);
      purDueAmoSet(0);
    } else {
      let dueAmount = num(purTotalAmo) - num(purPaidAmo);
      purDueAmoSet(Number.isFinite(dueAmount) ? round2(dueAmount) : 0);
    }
  }, [purPaidAmo, purTotalAmo, selectedSupplier]);

  useEffect(() => {
    let total;
    total = num(product.prod_purchase_rate) * num(product.prod_qty);
    cartTotalSet(round2(total));
  }, [product]);

  useEffect(() => {
    const total = purchaseCart.reduce((prev, curr) => {
      return prev + num(curr.prod_purchase_rate) * num(curr.prod_qty);
    }, 0);
    subTotalSet(round2(total));
  }, [purchaseCart]);

  useEffect(() => {
    setPurchaseData((pd) => ({ ...pd, pur_subtotal_amount: subTotal }));
  }, [subTotal]);

  // ---- AUTO SYNC VAT/AIT/DISCOUNT when subtotal or discount changes
  useEffect(() => {
    // Discount depends on Subtotal
    if (discountMode === "percent") {
      pur_discount_amount_set(
        round2((num(subTotal) * num(pur_discount_percent)) / 100)
      );
    } else {
      pur_discount_percent_set(
        subTotal
          ? round2((num(pur_discount_amount) * 100) / num(subTotal))
          : 0
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subTotal, pur_discount_percent]);

  useEffect(() => {
    // VAT calculated on DISCOUNTED amount (Subtotal - Discount)
    const afterDiscount = num(subTotal) - num(pur_discount_amount);

    if (vatMode === "percent") {
      pur_vat_amount_set(round2((afterDiscount * num(pur_vat_percent)) / 100));
    } else {
      pur_vat_percent_set(
        afterDiscount ? round2((num(pur_vat_amount) * 100) / afterDiscount) : 0
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subTotal, pur_discount_amount, pur_vat_percent, vatMode]);

  useEffect(() => {
    // AIT calculated on DISCOUNTED amount (Subtotal - Discount)
    const afterDiscount = num(subTotal) - num(pur_discount_amount);

    if (aitMode === "percent") {
      pur_ait_amount_set(round2((afterDiscount * num(pur_ait_percent)) / 100));
    } else {
      pur_ait_percent_set(afterDiscount ? round2((num(pur_ait_amount) * 100) / afterDiscount) : 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subTotal, pur_discount_amount, pur_ait_percent, aitMode]);

  // ---- loading data (floors/racks before mapping details)
  useEffect(() => {
    const init = async () => {
      currentRouteSet(pathSpliter(location.pathname, 1));

      await Promise.all([
        getPurchaseInvoice(),
        getEmployees(),
        getSuppliers(),
        getIndividualProducts(),
        getTranAccs(),
      ]);

      await getFloors();
      await getRacks();

      setFilteredRacks(racks);

      const socket = socketIOClient(API_URL, { transports: ["polling", "websocket"] });
      socket.on("purchaseInvoice", (data) => {
        setPurchaseData((prev) => ({ ...prev, invoice_no: data }));
      });

      if (pathSpliter(location.pathname, 3) !== undefined) {
        try {
          const res = await axios.post(
            `${API_URL}/api/get-purchase-with-details`,
            {
              reqPayload: {
                purchaseId: parseFloat(pathSpliter(location.pathname, 3)),
              },
            },
            { headers: { "auth-token": authInfo.token } }
          );

          let purchase = res.data.message[0];
          let purchaseDetails = res.data.message[0].details || [];

          selectedEmployeeSet({
            employee_id: purchase.pur_emp_id,
            employee_name: purchase.employee_name,
          });

          if (purchase.pur_qc_id) {
            selectedQCSet({
              employee_id: purchase.pur_qc_id,
              employee_name: purchase.qc_employee_name,
            });
          }

          selectedSupplierSet({
            supplier_id: purchase.pur_supplier_id,
            supplier_name:
              purchase.pur_supplier_type === "general"
                ? "General Supplier"
                : purchase.supplier_name,
            supplier_type: purchase.pur_supplier_type,
            display_text: purchase.supplier_name,
          });

          setPurchaseData((prev) => ({
            ...prev,
            invoice_no: purchase.pur_invoice_no,
            supplier_name: purchase.supplier_name,
            display_text: purchase.supplier_name,
            supplier_mobile_no: purchase.supplier_mobile_no,
            supplier_address: purchase.supplier_address,
            pur_transport_cost: purchase.pur_transport_cost,
            pur_supplier_type: purchase.pur_supplier_type,
            pur_supplier_id: purchase.pur_supplier_id,
          }));

          handleDateChangeSet(purchase.pur_created_isodt);

          // keep stored values + set mode defaults
          pur_vat_amount_set(num(purchase.pur_vat_amount));
          pur_vat_percent_set(num(purchase.pur_vat_percent));
          pur_ait_amount_set(num(purchase.pur_ait_amount));
          pur_ait_percent_set(num(purchase.pur_ait_percent));
          pur_discount_amount_set(num(purchase.pur_discount_amount));
          pur_discount_percent_set(num(purchase.pur_discount_percent));

          purTotalAmoSet(num(purchase.pur_total_amount));
          purPaidAmoSet(num(purchase.pur_paid_amount));
          purDueAmoSet(num(purchase.pur_due_amount));

          selectedSupplierPayMethodSet({
            pay_method_id: purchase.pur_pay_method,
            pay_method: purchase.pur_pay_method,
          });
          selectedSupplierPayAccSet({
            bank_display_name: purchase.bank_display_name,
            bank_acc_id: purchase.pur_bank_id,
          });

          const purchaseCartGet = purchaseDetails.map((ele) => {
            const floorObj = floors.find(
              (f) => f.prod_floor_id === ele.pur_prod_floor
            );
            const rackObj = racks.find(
              (r) => r.prod_rack_id === ele.pur_prod_rack
            );

            return {
              prod_id: ele.pur_prod_id,
              prod_name: ele.prod_name,
              prod_purchase_rate: ele.pur_rate,
              prod_sale_rate: ele.sale_rate,
              prod_floor_name: floorObj?.prod_floor_name || "",
              prod_floor_id: ele.pur_prod_floor,
              prod_rack_name: rackObj?.prod_rack_name || "",
              prod_rack_id: ele.pur_prod_rack,
              prod_qty: ele.pur_total_qty || ele.prod_qty,
              prod_due_qty: ele.pur_due_qty || 0,
              prod_total: ele.pur_total_amount,
              prod_brand: ele.prod_brand_name || "",
              // Set functionality fields
              prod_unit_name: ele.prod_unit_name || "",
              prod_set_no: ele.prod_set_no || "",
              prod_set_qty: ele.prod_set_qty || "",
              entered_set_no: ele.entered_set_no || "",
            };
          });

          purchaseCartSet(purchaseCartGet);
        } catch (err) {
          console.error("Error loading purchase details", err);
        }
      }
      // Check if redirect from Invoice (via location.state or localStorage)
      else {
        let returnData = null;
        let isFromReturn = false;

        // Try location.state first (for SPA navigation)
        if (location.state && location.state.purchaseData && location.state.fromPurchase) {
          returnData = location.state.purchaseData;
          isFromReturn = true;
        }
        // Fallback to localStorage
        else {
          const storedData = localStorage.getItem('returnToPurchaseEntry');
          if (storedData) {
            try {
              const parsedData = JSON.parse(storedData);
              returnData = parsedData.purchaseData;
              isFromReturn = parsedData.fromPurchase;
              localStorage.removeItem('returnToPurchaseEntry');
            } catch (e) {
              console.error('Error parsing returnToPurchaseEntry from localStorage:', e);
            }
          }
        }

        if (returnData && isFromReturn) {
          const purchase = returnData;
          // Auto-fill Supplier
          selectedSupplierSet({
            supplier_id: purchase.pur_supplier_id,
            supplier_name: purchase.supplier_name,
            display_text: purchase.supplier_name,
          });

          // Auto-fill Employee
          selectedEmployeeSet({
            employee_id: purchase.pur_emp_id,
            employee_name: purchase.employee_name,
          });

          // Auto-fill Cart (Products)
          if (purchase.details && Array.isArray(purchase.details)) {
            const purchaseCartGet = purchase.details.map((ele) => {
              const floorObj = floors.find(
                (f) => f.prod_floor_id === ele.pur_prod_floor
              );
              const rackObj = racks.find(
                (r) => r.prod_rack_id === ele.pur_prod_rack
              );

              return {
                prod_id: ele.pur_prod_id,
                prod_name: ele.prod_name,
                prod_purchase_rate: ele.pur_rate,
                prod_sale_rate: ele.sale_rate,
                prod_floor_name: floorObj?.prod_floor_name || "",
                prod_floor_id: ele.pur_prod_floor,
                prod_rack_name: rackObj?.prod_rack_name || "",
                prod_rack_id: ele.pur_prod_rack,
                prod_qty: ele.pur_total_qty || ele.prod_qty,
                prod_due_qty: ele.pur_due_qty || 0,
                prod_total: ele.pur_total_amount,
                prod_brand: ele.prod_brand_name || "",
                // Set functionality fields
                prod_unit_name: ele.prod_unit_name || "",
                prod_set_no: ele.prod_set_no || "",
                prod_set_qty: ele.prod_set_qty || "",
                entered_set_no: ele.entered_set_no || "",
              };
            });
            purchaseCartSet(purchaseCartGet);
          }

          // Auto-fill Financials
          pur_discount_amount_set(num(purchase.pur_discount_amount));
          pur_discount_percent_set(num(purchase.pur_discount_percent));
          pur_vat_amount_set(num(purchase.pur_vat_amount));
          pur_vat_percent_set(num(purchase.pur_vat_percent));
          pur_ait_amount_set(num(purchase.pur_ait_amount));
          pur_ait_percent_set(num(purchase.pur_ait_percent));
        }
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---- filter racks by selected floor
  useEffect(() => {
    if (selectedFloor) {
      const filtered = racks.filter(
        (r) => r.prod_floor_id === selectedFloor.prod_floor_id
      );
      setFilteredRacks(filtered);
    } else {
      setFilteredRacks(racks);
    }
  }, [selectedFloor, racks]);

  // ---- data fetchers
  const getTranAccs = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/get-bank-accounts`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );
      supplierPayAccsSet(res.data.message);
    } catch { }
  };

  const getContactPersons = async (id) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/get-supplier-contact-persons`,
        { customer_id: id },
        {
          headers: { "auth-token": authInfo.token },
        }
      );
      contactPersonsSet(response.data.message);
    } catch (error) {
      console.error("Error fetching contact persons:", error);
    }
  };

  useEffect(() => {
    if (selectedSupplier) {
      getContactPersons(selectedSupplier.supplier_id);
    }

    // Update due/received qty for the currently selected product when supplier changes
    if (product.prod_id) {
      const fetchUpdatedQuantities = async () => {
        try {
          const response = await axios.post(
            `${API_URL}/api/get-product-due-qty`,
            {
              supplierId: selectedSupplier ? selectedSupplier.supplier_id : 0,
              productId: product.prod_id
            },
            { headers: { 'auth-token': authInfo.token } }
          );
          if (!response.data.error) {
            setProduct((prev) => ({
              ...prev,
              prod_due_qty: response.data.dueQty || 0,
              prod_received_qty: response.data.receivedQty || 0
            }));
          }
        } catch (error) {
          console.error("Error updating quantities on supplier change:", error);
        }
      };
      fetchUpdatedQuantities();
    }
  }, [selectedSupplier]);

  const getPurchaseInvoice = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/get-purchase-invoce`, {
        headers: { "auth-token": authInfo.token },
      });
      setPurchaseData((pd) => ({ ...pd, invoice_no: res.data.message }));
    } catch { }
  };

  const getSuppliers = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/get-suppliers`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );
      res.data.message.unshift({
        supplier_id: 0,
        supplier_address: "",
        supplier_mobile_no: "",
        supplier_name: "General Supplier",
        display_text: "General Supplier",
      });
      suppliersSet(res.data.message);
    } catch { }
  };

  const getIndividualProducts = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/get-individual-products`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );
      setIndividualProducts(res.data.message);
    } catch { }
  };

  const getEmployees = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/get-employees`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );
      employeesSet(res.data.message);
    } catch { }
  };

  const getFloors = async () => {
    try {
      const res = await axios.post(`${API_URL}/api/get-floors`, null, {
        headers: { "auth-token": authInfo.token },
      });
      floorsSet(res.data.message || []);
    } catch {
      floorsSet([]);
    }
  };

  const getRacks = async () => {
    try {
      const res = await axios.post(`${API_URL}/api/get-racks`, null, {
        headers: { "auth-token": authInfo.token },
      });
      racksSet(res.data.message || []);
      setFilteredRacks(res.data.message || []);
    } catch {
      racksSet([]);
      setFilteredRacks([]);
    }
  };

  // ---- cart ops
  const purchaseToCart = () => {
    if (selectedProduct == null) {
      swal({ title: "Select a product", icon: "warning" });
      return;
    }
    if (product.prod_purchase_rate < 0.1) {
      swal({ title: "Purchase rate is invalid.", icon: "warning" });
      return;
    }
    if (product.prod_qty < 1) {
      swal({ title: "Quantity is invalid.", icon: "warning" });
      return;
    }
    if (product.prod_sale_rate < 0) {
      swal({ title: "Sale rate is invalid.", icon: "warning" });
      return;
    }

    // Calculate final quantity and rate from the entered quantity and rate.
    let finalQty = product.prod_qty;
    let finalRate = product.prod_purchase_rate;
    let prod_total = num(product.prod_purchase_rate) * num(product.prod_qty);

    const storageProduct = {
      prod_id: product.prod_id,
      prod_brand_name: product.prod_brand,
      prod_qty: finalQty,
      prod_floor_id: floor.prod_floor_id,
      prod_rack_id: rack.prod_rack_id,
      prod_purchase_rate: finalRate,
    };

    const purchaseItem = {
      ...product,
      prod_qty: finalQty,
      prod_purchase_rate: finalRate,
      prod_total: round2(prod_total),
      prod_floor_name: floor.prod_floor_name,
      prod_floor_id: floor.prod_floor_id,
      prod_rack_id: rack.prod_rack_id,
      prod_rack_name: rack.prod_rack_name,
    };

    purchaseCartSet((prev) => mergePurchaseRow(prev, purchaseItem));
    storageCartSet((prev) => mergePurchaseRow(prev, storageProduct));

    setProduct({
      prod_purchase_rate: "",
      prod_sale_rate: 0,
      prod_id: 0,
      prod_name: "",
      prod_qty: "",
      prod_due_qty: 0,
      prod_total: 0,
      prod_brand: "",
      prod_color: "",
    });
    selectedProductSet(null);
    productRef.current.focus();
  };


  const purchaseCartRemove = (_row, index) => {
    let hardCopy = [...purchaseCart];
    hardCopy.splice(index, 1);
    purchaseCartSet(hardCopy);

    let storageCopy = [...storageCart];
    storageCopy.splice(index, 1);
    storageCartSet(storageCopy);
  };

  // ---- totals inputs (FIXED + bidirectional)
  let handleDiscountInput = (e) => {
    const { name, value } = e.target;

    if (name === "pur_discount_amount") {
      setDiscountMode("amount");
      const val = num(value);
      pur_discount_amount_set(val);
      const pct = subTotal ? round2((val * 100) / num(subTotal)) : 0;
      pur_discount_percent_set(pct);
    } else {
      setDiscountMode("percent");
      const pct = num(value);
      pur_discount_percent_set(pct);
      const amo = round2((num(subTotal) * pct) / 100);
      pur_discount_amount_set(amo);
    }
  };

  let handleVatInput = (e) => {
    const { name, value } = e.target;
    const afterDiscount = num(subTotal) - num(pur_discount_amount);

    if (name === "pur_vat_amount") {
      setVatMode("amount");
      const amo = num(value);
      pur_vat_amount_set(amo);
      const pct = afterDiscount ? round2((amo * 100) / afterDiscount) : 0;
      pur_vat_percent_set(pct);
    } else {
      setVatMode("percent");
      const pct = num(value);
      pur_vat_percent_set(pct);
      const amo = round2((afterDiscount * pct) / 100);
      pur_vat_amount_set(amo);
    }
  };

  let handleAitInput = (e) => {
    const { name, value } = e.target;
    const afterDiscount = num(subTotal) - num(pur_discount_amount);

    if (name === "pur_ait_amount") {
      setAitMode("amount");
      const amo = num(value);
      pur_ait_amount_set(amo);
      const pct = afterDiscount ? round2((amo * 100) / afterDiscount) : 0;
      pur_ait_percent_set(pct);
    } else {
      setAitMode("percent");
      const pct = num(value);
      pur_ait_percent_set(pct);
      const amo = round2((afterDiscount * pct) / 100);
      pur_ait_amount_set(amo);
    }
  };

  // ---- Excel handlers (reusing Opening Stock logic)
  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const okType =
      [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
      ].includes(file.type) || /\.(xlsx|xls|csv)$/i.test(file.name);

    if (!okType) {
      setExcelFileError("Please select only Excel or CSV file types");
      setExcelFile(null);
      return;
    }
    setExcelFileError(null);
    setExcelFile(file);
  };

  const showExcelPreview = (previewRows) => {
    const container = document.createElement("div");
    container.style.maxHeight = "400px";
    container.style.overflow = "auto";

    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.borderCollapse = "collapse";

    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");
    const headers = [
      "Row",
      "Category",
      "Brand",
      "Product Name",
      "Country Origin",
      "Floor",
      "Rack",
      "Quantity",
      "Purchase Rate",
      "Status",
    ];
    headers.forEach((h) => {
      const th = document.createElement("th");
      th.textContent = h;
      th.style.textAlign = "left";
      th.style.padding = "6px";
      th.style.borderBottom = "1px solid #ddd";
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    previewRows.forEach((row) => {
      const tr = document.createElement("tr");
      if (!row.isValid) {
        tr.style.backgroundColor = "#ffdddd";
        tr.style.color = "#c00";
      }
      const cells = [
        row._rowIndex + 2,
        row.Category || "",
        row.Brand || "",
        row["Product Name"] || "",
        row["Country Origin"] || "",
        row.Floor || "",
        row.Rack || "",
        row.Quantity ?? "",
        row["Purchase Rate"] ?? "",
        row.isValid ? "Valid" : row.validationError,
      ];
      cells.forEach((v) => {
        const td = document.createElement("td");
        td.textContent = `${v}`;
        td.style.padding = "6px";
        td.style.borderBottom = "1px solid #f0f0f0";
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    container.appendChild(table);

    swal({
      title: "Import Results",
      content: container,
      icon: "info",
      buttons: {
        confirm: { text: "OK", value: true, visible: true, closeModal: true },
      },
    });
  };

  const importExcelData = async () => {
    if (!excelFile) {
      swal({ title: "Please select an Excel file first", icon: "warning" });
      return;
    }

    try {
      setExcelImportStatus("Reading Excel...");
      const rawRows = await readExcelRows(excelFile);

      setExcelImportStatus("Validating...");
      const { validated, invalidRows, preview } = validateExcelRows(
        rawRows,
        individualProducts, // product master
        floors,
        racks
      );

      showExcelPreview(preview);

      if (validated.length === 0) {
        setExcelImportStatus(null);
        return;
      }

      setExcelImportStatus("Adding to cart...");
      const { purchaseCart: addedPC, storageCart: addedSC } =
        toPurchaseCartItems(validated);

      purchaseCartSet((prev) =>
        addedPC.reduce((acc, item) => mergePurchaseRow(acc, item), prev)
      );
      storageCartSet((prev) =>
        addedSC.reduce((acc, item) => mergePurchaseRow(acc, item), prev)
      );

      setExcelImportStatus(null);

      if (invalidRows.length === 0) {
        swal({
          title: `${validated.length} products imported successfully!`,
          icon: "success",
        });
      }
    } catch (err) {
      setExcelImportStatus(null);
      swal({
        title: "Error processing Excel file",
        text: err.message,
        icon: "error",
      });
    }
  };

  const resetForm = () => {
    localStorage.removeItem('purchaseCart');
    purchaseCartSet([]);
    storageCartSet([]);
    selectedSupplierSet(null);
    selectedEmployeeSet(null);
    selectedQCSet(null);
    selectedContactPersonSet(null);
    selectedProductSet(null);
    selectedFloorSet(null);
    selectedRackSet(null);
    setFilteredRacks(racks);
    setProduct({
      prod_id: "",
      prod_qty: "",
      prod_due_qty: 0,
      prod_received_qty: 0,
      prod_purchase_rate: "",
      prod_sale_rate: "",
      prod_total: "",
      prod_brand: "",
      prod_color: "",
    });
    product_brand_set("");
    product_color_set("");
    po_id_set("");
    setPurchaseData({
      invoice_no: "",
      supplier_name: "",
      display_text: "",
      supplier_mobile_no: "",
      supplier_address: "",
      pur_transport_cost: 0,
      pur_supplier_type: "retail",
      pur_supplier_id: 0,
      pur_note: "",
      pur_previous_due: 0,
    });
    handleDateChangeSet(new Date());
    setExcelFile(null);
    setExcelFileError(null);
    setExcelImportStatus(null);
    pur_vat_amount_set(0);
    pur_vat_percent_set(0);
    pur_ait_amount_set(0);
    pur_ait_percent_set(0);
    pur_discount_amount_set(0);
    pur_discount_percent_set(0);
    purTotalAmoSet(0);
    purPaidAmoSet(0);
    purDueAmoSet(0);
    selectedSupplierPayMethodSet({
      pay_method_id: "cash",
      pay_method: "cash",
    });
    selectedSupplierPayAccSet(null);
    contactPersonsSet([]);

    // Clear route state
    if (history) history.replace("/purchase/purchase-entry");

    // Refresh invoice no
    getPurchaseInvoice();
  };

  // ---- save purchase
  let savePurchase = async () => {
    if (selectedSupplier == null) {
      swal({ title: "Supplier is Required.", icon: "warning" });
      return;
    }

    if (purchaseCart.length === 0) {
      swal({ title: "Sorry... your cart is Empty.", icon: "warning" });
      return;
    }

    if (purPaidAmo > 0 && selectedSupplierPayMethod == null) {
      swal({ title: "Select Payment Method", icon: "warning" });
      return;
    }

    if (
      purPaidAmo > 0 &&
      selectedSupplierPayMethod != null &&
      selectedSupplierPayMethod.pay_method_id === "bank" &&
      selectedSupplierPayAcc == null
    ) {
      swal({ title: "Select Payment Account", icon: "warning" });
      return;
    }

    if (
      parseFloat(purPaidAmo) <= 0 &&
      selectedSupplierPayMethod != null &&
      selectedSupplierPayMethod.pay_method_id === "bank"
    ) {
      swal({ title: "Paymentable Amount is 0", icon: "warning" });
      return;
    }

    let purId =
      pathSpliter(location.pathname, 3) !== undefined
        ? parseFloat(pathSpliter(location.pathname, 3))
        : 0;

    let purchase = {
      ...purchaseData,
      pur_po_id: po_id,
      pur_vat_amount: num(pur_vat_amount),
      pur_vat_percent: num(pur_vat_percent),
      pur_ait_amount: num(pur_ait_amount),
      pur_ait_percent: num(pur_ait_percent),
      pur_discount_amount: num(pur_discount_amount),
      pur_discount_percent: num(pur_discount_percent),
      pur_due_amount: num(purDueAmo),
      pur_paid_amount: num(purPaidAmo),
      pur_total_amount: num(purTotalAmo),
      pur_total_amount: num(purTotalAmo),
      pur_emp_id: selectedEmployee != null ? selectedEmployee.employee_id : 0,
      pur_qc_id: selectedQC != null ? selectedQC.employee_id : 0,
      pur_created_isodt: selectedDate,
      pur_id: purId,
      pur_supplier_id: selectedSupplier.supplier_id,
      pur_contact_person_id: selectedContactPerson?.contact_person_id || 0,
      pur_supplier_type:
        selectedSupplier.supplier_type == null
          ? "general"
          : selectedSupplier.supplier_type,
      pur_pay_method:
        selectedSupplierPayMethod != null
          ? selectedSupplierPayMethod.pay_method_id
          : "cash",
      pur_bank_id:
        selectedSupplierPayMethod == null ||
          selectedSupplierPayMethod.pay_method_id === "cash"
          ? 0
          : selectedSupplierPayAcc.bank_acc_id,
    };

    saveActionSet(true);
    let url = `/save-purchase`;
    if (pathSpliter(location.pathname, 3) !== undefined) {
      url = `/update-purchase`;
    }

    try {
      const purchaseResponse = await axios.post(
        `${API_URL}/api${url}`,
        { purchase, purchaseCart },
        { headers: { "auth-token": authInfo.token } }
      );

      if (!purchaseResponse.data.error) {
        await axios.post(
          `${API_URL}/api/save-storage`,
          { storageCart },
          { headers: { "auth-token": authInfo.token } }
        );

        let smg =
          pathSpliter(location.pathname, 3) !== undefined
            ? "Purchase updated "
            : "Purchase ";

        swal({
          title: `${smg} successfully. Do you want to view invoice?`,
          icon: "success",
          buttons: true,
        }).then((confirm) => {
          if (confirm) {
            history.push(
              `/purchase/purchase-invoice/${purchaseResponse.data.message.purchaseId}`
            );
            saveActionSet(false);
          } else {
            resetForm();
          }
        });
      } else {
        swal({ title: "Your Network problem....", icon: "warning" });
      }
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        error?.response?.data?.error ||
        error.message;
      swal({
        title: "Error saving purchase",
        text: backendMessage,
        icon: "error",
      });
    } finally {
      saveActionSet(false);
    }
  };

  return (
    <div className={classes.root}>
      <Paper
        className={classes.paper}
        style={{ marginTop: "-25px", marginBottom: "5px" }}
      >
        <h4
          style={{
            textAlign: "left",
            margin: 0,
            padding: 0,
            marginTop: "-10px",
            marginBottom: "2px",
          }}
        >
          Purchase Entry
        </h4>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={2}>
            <TextField
              label="invoice no"
              variant="outlined"
              size="small"
              className={classes.fullWidth}
              value={purchaseData.invoice_no}
              onChange={handleFromInput}
              name="invoice_no"
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              label="Chalan No"
              variant="outlined"
              value={po_id}
              className={classes.fullWidth}
              onChange={(e) => po_id_set(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  employeeRef.current.focus();
                }
              }}
              name="sale_invoice"
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Autocomplete
              size="small"
              autoHighlight
              openOnFocus
              style={{ width: "100%", height: "20px" }}
              options={employees}
              value={selectedEmployee}
              getOptionLabel={(option) => option.employee_name}
              onChange={(event, selectedObj) => {
                setPurchaseData((pd) => ({
                  ...pd,
                  pur_emp_id: selectedObj != null ? selectedObj.employee_id : 0,
                }));
                selectedEmployeeSet(selectedObj);
              }}
              renderInput={(params) => (
                <TextField
                  inputRef={employeeRef}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      purchaseDateRef.current.focus();
                    }
                  }}
                  {...params}
                  label="Purchase by"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Autocomplete
              size="small"
              autoHighlight
              openOnFocus
              style={{ width: "100%", height: "20px" }}
              options={employees}
              value={selectedQC}
              getOptionLabel={(option) => option.employee_name}
              onChange={(event, selectedObj) => {
                selectedQCSet(selectedObj);
              }}
              renderInput={(params) => (
                <TextField
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      purchaseDateRef.current.focus();
                    }
                  }}
                  {...params}
                  label="QC by"
                  variant="outlined"
                />
              )}
            />
          </Grid>

          <Grid item xs={0} sm={4}></Grid>
          <Grid item xs={12} sm={2} style={{ marginBottom: "-9px" }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                inputRef={purchaseDateRef}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    supplierRef.current.focus();
                  }
                }}
                style={{ width: "100%", marginTop: "" }}
                value={selectedDate}
                onChange={handleDateChangeSet}
                label="Purchase Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={8}>
          <Paper className={classes.paper}>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginTop: "-10px",
                marginBottom: "3px",
              }}
            >
              Supplier & product information
            </h4>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} className={classes.plusLinkDiv}>
                <Link className={classes.plusLink} to="/purchase/suppliers-manage">
                  +
                </Link>{" "}
                <Autocomplete
                  autoHighlight
                  size="small"
                  openOnFocus
                  value={selectedSupplier}
                  style={{ width: "100%" }}
                  options={suppliers}
                  onChange={async (event, selectedObj) => {
                    if (selectedObj == null) return;

                    setPurchaseData((pd) => ({
                      ...pd,
                      pur_supplier_id: selectedObj.supplier_id,
                      supplier_name: selectedObj.supplier_name,
                      supplier_address: selectedObj.supplier_address,
                      supplier_mobile_no: selectedObj.supplier_mobile_no,
                    }));

                    try {
                      const res = await axios.post(
                        `${API_URL}/api/get-supplier-due`,
                        { supplierId: selectedObj.supplier_id },
                        { headers: { "auth-token": authInfo.token } }
                      );

                      if (selectedObj.supplier_id === 0) {
                        setPurchaseData((pd) => ({
                          ...pd,
                          pur_previous_due: 0,
                          pur_supplier_type: "general",
                        }));
                      } else {
                        setPurchaseData((pd) => ({
                          ...pd,
                          pur_previous_due: res.data[0]?.dueAmount ?? 0,
                          pur_supplier_type: "general",
                        }));
                      }
                    } catch { }

                    selectedSupplierSet(selectedObj);
                  }}
                  getOptionLabel={(option) => option.display_text}
                  renderInput={(params) => (
                    <TextField
                      inputRef={supplierRef}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          contactPersonRef.current.focus();
                        }
                      }}
                      {...params}
                      label="Choose a Supplier "
                      variant="outlined"
                    />
                  )}
                />
                <TextField
                  label="supplier name"
                  style={{
                    display:
                      purchaseData.pur_supplier_type === "general" ? "" : "none",
                  }}
                  size="small"
                  variant="outlined"
                  name="supplier_name"
                  className={classes.inputField}
                  value={purchaseData.supplier_name}
                  onChange={handleTotalInput}
                  disabled={purchaseData.pur_supplier_id !== 0}
                />
                <TextField
                  label="supplier mobile"
                  size="small"
                  variant="outlined"
                  name="supplier_mobile_no"
                  className={classes.inputField}
                  value={purchaseData.supplier_mobile_no}
                  onChange={handleTotalInput}
                  disabled={purchaseData.pur_supplier_id !== 0}
                />
                <TextField
                  label="supplier address"
                  size="small"
                  variant="outlined"
                  name="supplier_address"
                  className={classes.inputField}
                  value={purchaseData.supplier_address}
                  onChange={handleTotalInput}
                  disabled={purchaseData.pur_supplier_id !== 0}
                />
                <br />
                <br />
                <Autocomplete
                  autoHighlight
                  size="small"
                  openOnFocus
                  style={{ width: "100%" }}
                  options={contactPersons || []}
                  value={selectedContactPerson}
                  loading={false}
                  onChange={(e, customer) => selectedContactPersonSet(customer)}
                  getOptionLabel={(option) => option.contact_person_name || ""}
                  renderInput={(params) => (
                    <TextField
                      inputRef={contactPersonRef}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          productRef.current.focus();
                        }
                      }}
                      {...params}
                      label="Choose a Contact Person"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} className={classes.plusLinkDiv}>
                <Link className={classes.plusLink} to="/administration/products-manage">
                  +
                </Link>

                <Autocomplete
                  autoHighlight
                  openOnFocus
                  value={selectedProduct}
                  style={{ width: "100%", height: "20px" }}
                  options={individualProducts}
                  size="small"
                  onChange={async (e, obj) => {
                    selectedProductSet(obj);
                    if (obj == null) return;
                    setProduct((prev) => ({
                      ...prev,
                      prod_purchase_rate: parseFloat(obj.prod_purchase_rate).toFixed(2),
                      prod_sale_rate: obj.prod_sale_rate,
                      prod_id: obj.prod_id,
                      prod_name: obj.prod_name,
                      prod_brand: obj.prod_brand_name,
                      prod_color: obj.prod_color_name,
                    }));
                    product_brand_set(obj.prod_brand_name);
                    product_color_set(obj.prod_color_name);

                    // Fetch due quantity for this supplier and product
                    if (selectedSupplier && obj.prod_id) {
                      try {
                        const response = await axios.post(
                          `${API_URL}/api/get-product-due-qty`,
                          {
                            supplierId: selectedSupplier.supplier_id,
                            productId: obj.prod_id
                          },
                          { headers: { 'auth-token': authInfo.token } }
                        );
                        if (!response.data.error) {
                          setProduct((prev) => ({
                            ...prev,
                            prod_due_qty: response.data.dueQty || 0,
                            prod_received_qty: response.data.receivedQty || 0
                          }));
                        }
                      } catch (error) {
                        console.error("Error fetching due qty:", error);
                      }
                    }

                    floorRef.current.focus();
                  }}
                  getOptionLabel={(option) =>
                    `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()
                  }
                  renderInput={(params) => (
                    <TextField
                      inputRef={productRef}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          floorRef.current.focus();
                        }
                      }}
                      {...params}
                      label="choose a product"
                      variant="outlined"
                    />
                  )}
                />
                <br />
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="text"
                      style={{ marginRight: "5px" }}
                      label="brand"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_brand}
                      onChange={(e) => {
                        product_brand_set(e.target.value);
                      }}
                      disabled
                    />
                  </Grid>
                  <Grid item sm={1}></Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="text"
                      label="country"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_color}
                      onChange={(e) => {
                        product_color_set(e.target.value);
                      }}
                      disabled
                    />
                  </Grid>
                </Grid>

                <br />
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      autoHighlight
                      openOnFocus
                      value={selectedFloor}
                      style={{ marginRight: "5px", width: "100%" }}
                      options={floors}
                      size="small"
                      onChange={(e, obj) => {
                        selectedFloorSet(obj);
                        setFloor({
                          prod_floor_id: obj?.prod_floor_id || 0,
                          prod_floor_name: obj?.prod_floor_name || "",
                        });
                      }}
                      getOptionLabel={(option) =>
                        option.prod_floor_name || "Unnamed Floor"
                      }
                      renderInput={(params) => (
                        <TextField
                          inputRef={floorRef}
                          {...params}
                          label="choose floor"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item sm={1}></Grid>
                  <Grid item xs={12} sm={5}>
                    <Autocomplete
                      autoHighlight
                      openOnFocus
                      value={selectedRack}
                      options={filteredRacks}
                      style={{ width: "100%" }}
                      size="small"
                      onChange={(e, obj) => {
                        if (obj == null) {
                          selectedRackSet(null);
                          setRack({ prod_rack_id: 0, prod_rack_name: "" });
                          return;
                        }
                        selectedRackSet(obj);
                        setRack({
                          prod_rack_id: obj.prod_rack_id,
                          prod_rack_name: obj.prod_rack_name,
                        });
                      }}
                      getOptionLabel={(option) =>
                        option.prod_rack_name || "Unnamed Rack"
                      }
                      renderInput={(params) => (
                        <TextField
                          inputRef={rackRef}
                          {...params}
                          label="choose rack"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <br />
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      style={{ marginRight: "5px" }}
                      inputRef={purchaseRateRef}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          quantityRef.current.focus();
                        }
                      }}
                      type="number"
                      label="purchase rate"
                      size="small"
                      value={product.prod_purchase_rate}
                      onChange={productHandle}
                      name="prod_purchase_rate"
                      variant="outlined"
                      className={classes.inputField}
                    />
                  </Grid>
                  <Grid item sm={1}></Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      label="quantity"
                      type="number"
                      inputRef={quantityRef}
                      onKeyDown={(event) => {
                        if (event.key === "." || event.key === "e" || event.key === "-") {
                          event.preventDefault();
                        }
                        if (event.key === "Enter") {
                          dueQuantityRef.current.focus();
                        }
                      }}
                      value={product.prod_qty}
                      variant="outlined"
                      size="small"
                      onChange={productHandle}
                      name="prod_qty"
                      className={classes.inputField}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}></Grid>

                  <Grid item xs={12} sm={3}>
                    <br />
                    <TextField
                      label="Received Quantity"
                      type="number"
                      value={product.prod_received_qty || 0}
                      variant="outlined"
                      size="small"
                      disabled
                      className={classes.inputField}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <br />
                    <TextField
                      label="Due Quantity"
                      type="number"
                      inputRef={dueQuantityRef}
                      onKeyDown={(event) => {
                        if (event.key === "." || event.key === "e" || event.key === "-") {
                          event.preventDefault();
                        }
                        if (event.key === "Enter") {
                          purchaseToCartRef.current.click();
                        }
                      }}
                      value={product.prod_due_qty}
                      variant="outlined"
                      size="small"
                      onChange={productHandle}
                      name="prod_due_qty"
                      className={classes.inputField}
                    />
                  </Grid>
                </Grid>

                <Grid container alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="total"
                      type="number"
                      disabled
                      value={cartTotal}
                      onChange={productHandle}
                      name="prod_total"
                      size="small"
                      variant="outlined"
                      className={classes.inputField}
                    />
                  </Grid>
                  <Grid item xs />
                  <Grid item>
                    <Button
                      buttonRef={purchaseToCartRef}
                      onClick={purchaseToCart}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                      }}
                      variant="contained"
                      color="primary"
                      size="small"
                      className={classes.button}
                      startIcon={<SaveIcon />}
                    >
                      Add To Cart
                    </Button>
                  </Grid>
                </Grid>

                {/* Excel Import Section */}
                <Grid container style={{ marginTop: "10px" }}>
                  <Grid item xs={12}>
                    <input
                      type="file"
                      onChange={handleFile}
                      accept=".xlsx, .xls, .csv"
                      style={{ display: "none" }}
                      id="excel-upload"
                    />
                    <label htmlFor="excel-upload">
                      <Button
                        variant="contained"
                        color="secondary"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                        style={{ marginRight: "10px" }}
                      >
                        Choose Excel File
                      </Button>
                    </label>
                    {excelFile && (
                      <span style={{ marginRight: "10px" }}>
                        {excelFile.name}
                      </span>
                    )}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={importExcelData}
                      disabled={!excelFile}
                      startIcon={<SaveIcon />}
                    >
                      Import Data
                    </Button>
                    {excelImportStatus && (
                      <div
                        style={{
                          color: "#666",
                          marginTop: "5px",
                          fontSize: "0.8rem",
                        }}
                      >
                        {excelImportStatus}
                      </div>
                    )}
                    {excelFileError && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "5px",
                          fontSize: "0.8rem",
                        }}
                      >
                        {excelFileError}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Grid container>
            <Grid item xs={12}>
              <Paper className={classes.paper} style={{ marginTop: "5px" }}>
                <h4
                  style={{
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    marginTop: "-10px",
                    marginBottom: "3px",
                  }}
                >
                  Purchase Cart
                </h4>
                <TableContainer>
                  <Table className={classes.table} size="small">
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                        <TableCell align="center" style={{ fontWeight: "bold", width: "50px" }}>SL</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>Product</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Brand</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Floor</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Rack</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>Rate</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Total Qty</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Due Qty</TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>Subtotal</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {purchaseCart.map((row, index) => {
                        const lineSubtotal = parseFloat(row.prod_total);

                        return (
                          <TableRow key={`${row.prod_id}-${index}`}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="left">{row.prod_name}</TableCell>
                            <TableCell align="center">{row.prod_brand}</TableCell>
                            <TableCell align="center">{row.prod_floor_name}</TableCell>
                            <TableCell align="center">{row.prod_rack_name}</TableCell>
                            <TableCell align="center">
                              {format(parseFloat(row.prod_purchase_rate).toFixed(2))}
                            </TableCell>
                            <TableCell align="center">{row.prod_qty}</TableCell>
                            <TableCell align="center">{row.prod_due_qty || 0}</TableCell>
                            <TableCell align="right">
                              {format(lineSubtotal.toFixed(2))}
                            </TableCell>
                            <TableCell align="center">
                              <RemoveCircleIcon
                                style={{
                                  cursor: "pointer",
                                  color: "#FF0202",
                                  marginLeft: "2px",
                                }}
                                onClick={() => {
                                  purchaseCartRemove(row, index);
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        )
                      })}

                      {purchaseCart.length !== 0 ? (
                        <TableRow style={{ backgroundColor: "#fafafa" }}>
                          <TableCell colSpan={8} align="right" style={{ fontWeight: "bold", fontSize: "14px" }}>
                            Total Amount:
                          </TableCell>
                          <TableCell align="right" style={{ fontWeight: "bold", fontSize: "14px" }}>
                            {format(parseFloat(purTotalAmo).toFixed(2))}
                          </TableCell>
                          <TableCell />
                        </TableRow>
                      ) : (
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                            Cart is empty.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {purchaseCart.length !== 0 && (
                  <>
                    {/* Amount Details Summary */}
                    <TableContainer style={{ marginTop: "10px" }}>
                      <Table className={classes.table} size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                              Subtotal:
                            </TableCell>
                            <TableCell align="right" style={{ border: "none", paddingRight: "20px", minWidth: "120px" }}>
                              {format(parseFloat(subTotal || 0).toFixed(2))}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                              Discount ({pur_discount_percent}%):
                            </TableCell>
                            <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                              -{format(parseFloat(pur_discount_amount || 0).toFixed(2))}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                              VAT ({pur_vat_percent}%):
                            </TableCell>
                            <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                              +{format(parseFloat(pur_vat_amount || 0).toFixed(2))}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                              AIT ({pur_ait_percent}%):
                            </TableCell>
                            <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                              +{format(parseFloat(pur_ait_amount || 0).toFixed(2))}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                              Transport Cost:
                            </TableCell>
                            <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                              +{format(parseFloat(purchaseData.pur_transport_cost || 0).toFixed(2))}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="right" style={{ fontWeight: "bold", fontSize: "16px", borderTop: "2px solid #333", paddingRight: "20px" }}>
                              Grand Total:
                            </TableCell>
                            <TableCell align="right" style={{ fontWeight: "bold", fontSize: "16px", borderTop: "2px solid #333", paddingRight: "20px" }}>
                              {format(parseFloat(purTotalAmo || 0).toFixed(2))}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Purchase Note */}
                    <TableContainer>
                      <Table className={classes.table} size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ width: "325px" }}>
                              <TextareaAutosize
                                onChange={handleTotalInput}
                                name="pur_note"
                                value={purchaseData.pur_note || ""}
                                style={{
                                  float: "left",
                                  marginTop: "20px",
                                  width: "325px",
                                }}
                                aria-label="Purchase Note..."
                                rowsMin={3}
                                placeholder="purchase Note..."
                              />
                            </TableCell>
                            <TableCell />
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginTop: "-10px",
                marginBottom: "3px",
              }}
            >
              Amount Details
            </h4>
            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="number"
                  style={{ marginRight: "5px" }}
                  label="Subtotal"
                  size="small"
                  disabled
                  value={purchaseData.pur_subtotal_amount}
                  inputRef={subTotalRef}
                  onChange={handleTotalInput}
                  variant="outlined"
                  className={classes.inputField}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  style={{ marginRight: "5px" }}
                  size="small"
                  label="Current Due"
                  disabled
                  variant="outlined"
                  className={classes.inputField}
                  value={purchaseData.pur_previous_due}
                  onChange={handleTotalInput}
                  name="pur_previous_due"
                />
              </Grid>
            </Grid>

            {/* VAT (FIXED: correct state bindings) */}
            <Grid container>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="number"
                  label="VAT (TK)"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={pur_vat_amount}
                  inputRef={vatRef}
                  name="pur_vat_amount"
                  onChange={handleVatInput}
                  onKeyDown={stopEnter}
                  disabled={true}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  label="VAT (%)"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={pur_vat_percent}
                  name="pur_vat_percent"
                  onChange={handleVatInput}
                  onKeyDown={stopEnter}
                />
              </Grid>
            </Grid>

            {/* AIT (FIXED: correct state bindings) */}
            <Grid container>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="number"
                  label="AIT (TK)"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={pur_ait_amount}
                  inputRef={aitRef}
                  name="pur_ait_amount"
                  onChange={handleAitInput}
                  onKeyDown={stopEnter}
                  disabled={true}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  label="AIT (%)"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={pur_ait_percent}
                  name="pur_ait_percent"
                  onChange={handleAitInput}
                  onKeyDown={stopEnter}
                />
              </Grid>
            </Grid>

            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="number"
                  style={{ marginRight: "5px" }}
                  size="small"
                  label="Discount(TK)"
                  variant="outlined"
                  className={classes.inputField}
                  value={pur_discount_amount}
                  onChange={handleDiscountInput}
                  name="pur_discount_amount"
                  inputRef={discountRef}
                  onKeyDown={stopEnter}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  onChange={handleDiscountInput}
                  label="Discount (%)"
                  size="small"
                  variant="outlined"
                  className={classes.inputField}
                  value={pur_discount_percent}
                  name="pur_discount_percent" // FIXED
                  inputRef={discountPercentRef}
                  onKeyDown={stopEnter}
                />
              </Grid>
            </Grid>

            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="number"
                  style={{ marginRight: "5px" }}
                  size="small"
                  label="Total"
                  disabled
                  variant="outlined"
                  className={classes.inputField}
                  value={purTotalAmo}
                  onChange={handleTotalInput}
                  name="purTotalAmo"
                  inputRef={purTotalRef}
                />
              </Grid>
              <Grid item xs={0} sm={1}></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  onChange={handleTotalInput}
                  label="Transport Cost"
                  size="small"
                  variant="outlined"
                  className={classes.inputField}
                  value={purchaseData.pur_transport_cost}
                  name="pur_transport_cost"
                  inputRef={transportRef}
                  onKeyDown={stopEnter}
                />
              </Grid>
            </Grid>

            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={5}>
                <TextField
                  type="number"
                  label="Paid"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={purPaidAmo}
                  onChange={handlePaidInput}
                  name="purPaidAmo"
                  disabled={
                    selectedSupplier !== null && selectedSupplier.supplier_id == 0
                  }
                  inputRef={paidRef}
                  onKeyDown={stopEnter}
                />
              </Grid>

              <Grid item xs={0} sm={1}></Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  label="Due"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={purDueAmo}
                  disabled
                  onChange={handleDueInput}
                  name="purDueAmo"
                  inputRef={dueRef}
                />
              </Grid>
            </Grid>

            <Grid container>
              {purPaidAmo > 0 && (
                <Grid
                  item
                  xs={12}
                  sm={5}
                  className={classes.plusLinkDiv}
                  style={{ marginTop: "15px", marginBottom: "10px" }}
                >
                  <Autocomplete
                    style={{ width: "100%" }}
                    options={supplierPayMethods}
                    size="small"
                    autoHighlight
                    openOnFocus
                    getOptionLabel={(option) => option.pay_method}
                    value={selectedSupplierPayMethod}
                    onChange={(event, selectedObj) => {
                      selectedSupplierPayMethodSet(selectedObj);
                      if (
                        selectedObj != null &&
                        selectedObj.pay_method_id === "cash"
                      ) {
                        selectedSupplierPayAccSet(null);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Payment Method" variant="outlined" />
                    )}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={1}></Grid>
              {purPaidAmo > 0 &&
                selectedSupplierPayMethod != null &&
                selectedSupplierPayMethod.pay_method === "bank" && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={classes.plusLinkDiv}
                    style={{
                      display:
                        selectedSupplierPayMethod != null &&
                          selectedSupplierPayMethod.pay_method_id === "bank"
                          ? "block"
                          : "none",
                      marginTop: "15px",
                      marginBottom: "10px",
                    }}
                  >
                    <Autocomplete
                      style={{ width: "100%" }}
                      options={supplierPayAccs}
                      size="small"
                      autoHighlight
                      openOnFocus
                      getOptionLabel={(option) => option.bank_display_name}
                      value={selectedSupplierPayAcc}
                      onChange={(event, selectedObj) => {
                        selectedSupplierPayAccSet(selectedObj);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Bank account" variant="outlined" />
                      )}
                    />
                  </Grid>
                )}
            </Grid>

            <Grid container style={{ paddingRight: "1px" }}>
              <Grid item xs={12} sm={6}>
                <LoadingButton
                  style={{ marginTop: "5px", fontSize: "18px", float: "left" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  buttonRef={savePurchaseRef}
                  onClick={savePurchase}
                  className={classes.button}
                  startIcon={<SaveIcon />}
                  loading={saveAction}
                >
                  Purchase
                </LoadingButton>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button
                  style={{ marginTop: "5px", fontSize: "10px", float: "right" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={resetForm}
                  className={classes.button}
                  startIcon={<SaveIcon />}
                >
                  New Purchase
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: "100%",
    marginTop: "5px",
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
    textDecoration: "none",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  fullWidth: {
    width: "100%",
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, { currentRouteSet })(PurchaseEntry);
